import React from 'react';
import T from 'components/T';
import { Field } from 'redux-form';
import { M } from '@dashboard-experience/mastodon';
import PropTypes from 'prop-types';
import DOMPurify from 'isomorphic-dompurify';
import { Input } from 'components/fields';
import * as V from 'lib/validations';
import { getFieldKey } from 'utils';
import useT from 'hooks/useT';
import { bestAvailableDisplayText } from './helpers';

function ConsentContent({ field, company }) {
  return (
    <div className='well well-sm'>
      <T
        value={`components.Report.Verification.MatrixVerification.${field.name}.contentTitle`}
        dangerousHTML
      />
      <p>
        <T
          data-testid='consentDynamicContent'
          value={`components.Report.Verification.MatrixVerification.${field.name}.content`}
          company={company}
        />
      </p>
    </div>
  );
}

ConsentContent.propTypes = {
  field: PropTypes.object.isRequired,
  company: PropTypes.string,
};

ConsentContent.defaultProps = {
  company: '',
};

function MatrixConsentContainer({ field, company }) {
  const { t } = useT();
  if (!field) return null;

  const fieldKey = getFieldKey(field);

  return (
    <M.Container>
      <div data-testid={`consent-field-${field.name}`} className='html-field'>
        <h2>{bestAvailableDisplayText(field, 'header')}</h2>
        <hr />
        {field.content ? (
          <div
            className='well well-sm'
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(field.content),
            }}
          />
        ) : (
          <ConsentContent field={field} company={company} />
        )}
        <M.Container.Row>
          <h3>
            {t(
              'components.Report.Verification.MatrixVerification.nameAuthorization',
            )}
          </h3>
        </M.Container.Row>
        <M.Container.Row>
          <M.Container.Col>
            <Field
              type='text'
              testId={fieldKey}
              name={fieldKey}
              label={t(
                'components.Report.Verification.MatrixVerification.fullName',
              )}
              component={Input}
              context={fieldKey}
              validate={[V.required, V.nameMatches]}
              placeholder={t(
                'components.Report.Verification.MatrixVerification.fullName',
              )}
            />
          </M.Container.Col>
        </M.Container.Row>
      </div>
    </M.Container>
  );
}

MatrixConsentContainer.propTypes = {
  field: PropTypes.object,
  company: PropTypes.string,
};

MatrixConsentContainer.defaultProps = {
  field: null,
  company: '',
};

export default MatrixConsentContainer;
